import React from "react";
import { RightOutlined } from "@ant-design/icons";
import "./FilaTocable.scss";

/**
 * =============================================================================
 * FILA TOCABLE
 * =============================================================================
 * La primitiva con la que se construyen las tarjetas en movil. Existe porque
 * hoy cada tarjeta resuelve lo mismo de una forma distinta, y ninguna del todo
 * bien: en una la zona sensible es un icono de 24 px dentro de una fila de 113,
 * en otra fallar por seis pixeles abre el detalle en vez de borrar.
 *
 * Lo que garantiza:
 *
 *  - Toda la fila es la diana, no un trozo.
 *  - Se puede llegar con el teclado y se ve donde esta el foco.
 *  - Lo que va en el hueco del kebab no dispara la fila: ese contenedor para
 *    el clic antes de que suba.
 *
 * Las alturas son las cinco canonicas y no hay una sexta: 64 para una fila
 * simple, 88 cuando su identidad puede ocupar dos lineas (el caso frances), 96
 * con miniatura, 144 con barra de acciones y 212 para una tarjeta de decision.
 * =============================================================================
 */
export function FilaTocable({
  alto = 64,
  onTocar,
  kebab,
  chevron = true,
  as: Raiz = "div",
  className = "",
  children,
  ...resto
}) {
  const activar = (evento) => {
    if (evento.key === "Enter" || evento.key === " ") {
      evento.preventDefault();
      onTocar?.(evento);
    }
  };

  return (
    // `resto` va DESPUES para que quien la use pueda sobreescribir cualquiera
    // de estos atributos. Hoy nadie lo hace: la fila se comporta como un boton
    // y asi se anuncia.
    <Raiz
      role="button"
      tabIndex={0}
      onClick={onTocar}
      onKeyDown={activar}
      className={`revi-fila-tocable revi-fila-tocable--${alto} ${className}`}
      {...resto}
    >
      <div className="revi-fila-tocable__cuerpo">{children}</div>

      {kebab ? (
        <div className="revi-fila-tocable__kebab">{kebab}</div>
      ) : chevron ? (
        <RightOutlined className="revi-fila-tocable__chevron" aria-hidden />
      ) : null}
    </Raiz>
  );
}
